import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { KnowledgePageLoadingSkeleton } from '@jira/spa-apps__knowledge-page/src/KnowledgePageLoadingSkeleton.tsx';
import { KnowledgePageEntryPoint as main } from '@jira/spa-apps__knowledge-page/src/knowledgePage.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/no-restricted-import -- business Agent Context route needs the BusinessOnboarding + right sidebars from businessProjectLayout, matching all other business route entries
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { jiraBusinessAgentContextRoute } from '@jira/router-routes__business-agent-context-routes/src/jiraBusinessAgentContextRoute.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const jiraBusinessAgentContextEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
		horizontalNavigation: jiraHorizontalNavEntrypoint,
	});

export const jiraBusinessAgentContextRouteEntry: Route = createEntry(
	jiraBusinessAgentContextRoute,
	() => ({
		group: 'classic-business',
		perfMetricKey: 'business.agent-context',
		layout: businessProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		entryPoint() {
			return expValEquals('jira-agent-context-experiment', 'isEnabled', true, false)
				? jiraBusinessAgentContextEntryPoint
				: notFoundPageEntrypoint;
		},

		resources: [
			...getNavigationResources(),
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			projectThemeResource,
		],
		forPaint: [LazyAtlassianNavigation],
		skeleton: KnowledgePageLoadingSkeleton,
		ufoName: 'business-agent-context',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		supportsProjectTheme: 'full',
	}),
);
